<div class="row">

    <div id="toScroll"></div>
    <div class="col-12 pt-3 text-center inputResponse pb-2"
         *ngIf="completed < getSize(questions)">
        <div class="mb-3" *ngIf="selectDirection">
            <p>A quale domanda vuoi rispondere?</p>
            <span class="btn btn-primary  btn-outline-primary btn-rounded mr-2"
                  (click)="setDirection('v', intersecQuestionV, intersecWordV)">Verticale</span>
            <span class="btn btn-primary btn-rounded btn-outline-primary"
                  (click)="setDirection('h', intersecQuestionH, intersecWordH)">Orizzontale</span>

        </div>
        <p *ngIf="!selectedQuestion">Seleziona una cella</p>
        <p>
            {{ questionNumber }} <span *ngIf="direction === 'v'">verticale</span>
            <span *ngIf="direction === 'h'">orizzontale</span>
        </p>
        <h5 *ngIf="!selectDirection" [innerHTML]="selectedQuestion"></h5>
        <form [formGroup]="form" *ngIf="!selectDirection">
            <div class="input-group mb-3 mt-3">
                <input
                        type="text"
                        class="form-control"
                        formControlName="answer"
                        [attr.disabled]="selectedQuestion === '' ? 'disabled' : null"
                        [class.alerts-border]="error"
                        [class.success-border]="success"
                        placeholder="Inserisci la risposta"
                        aria-label="Inserisci la risposta"
                        aria-describedby="basic-addon2"
                        #answer
                />
                <div class="input-group-append">
                    <button class="btn btn-response"
                            #invia
                            [attr.disabled]="selectedQuestion === '' ? 'disabled' : null"
                            (click)="getAnswer()">
                        Invia
                    </button>
                </div>
            </div>
        </form>
        <hr/>
    </div>
</div>

<div class="row inputResponse">
    <table>
        <tr *ngFor="let row of lettersTable">
            <td *ngFor="let col of row.celle" class="text-center" [class.active]="col.value"
                (click)="onLetterSelection(col.value, col.word.h, col.word.v, col.question.h, col.question.v)">
                <span class="hide" [class.show]="col.guessed"> {{col.value}} </span>
                <sup *ngIf="col.first">
                    <span *ngIf="!col.hideFirst">{{col.question.v}}{{col.question.h}}</span>
                    <span *ngIf="col.hideFirst==='h'">{{col.question.v}}</span>
                    <span *ngIf="col.hideFirst==='v'">{{col.question.h}}</span>
                </sup>
            </td>
        </tr>
    </table>
    <div class="col-12 mt-4">
        <div class="col-12 text-center" *ngIf="completed">
            <p class="text-center" (click)="showSolutions = !showSolutions"><em>Mostra le soluzioni</em></p>
        </div>
        <div class="col-12 text-center" *ngIf="showSolutions">
            <img [src]="soluzione" class="img-fluid" alt="">
        </div>
    </div>
</div>
